import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { H2Section } from 'bloko/blocks/header';
import Text, { TextSize } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import KMNumber from 'components/KMNumber';

import 'components/Admin/InvoiceDetail/TitleWithInvoiceNumber/Title.less';

const Title = ({ titleBlock, ...invoice }) => {
    return (
        <Fragment>
            <H2Section lite>
                {titleBlock}
                {NON_BREAKING_SPACE}
                <Text Element="span" size={TextSize.ExtraLarge}>
                    <KMNumber {...invoice} />
                </Text>
            </H2Section>
            <VSpacing base={4} />
        </Fragment>
    );
};

Title.propTypes = {
    titleBlock: PropTypes.string,
    invoice: PropTypes.shape({
        payerType: PropTypes.string,
    }),
};

export default Title;
